import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { FormItem } from "@freightsimple/ui-core/FormLayout/FormItem";
import type { UUID } from "@/Shared/types";
import type { SavedContact } from "@freightsimple/generated-dashboard-openapi-client/models/SavedContact";

interface SavedContactsDropdownProps {
  savedContactId: UUID;
  onSetSavedContactId: (_: string) => void;
  savedContacts: Array<SavedContact>;
}

const BookShipmentSavedContactsDropdown: React.FC<
  SavedContactsDropdownProps
> = (props: SavedContactsDropdownProps) => {
  function dropdownContactOptions(contacts: Array<SavedContact>) {
    if (!contacts) {
      return [];
    }
    return contacts.map((i) => ({
      value: i.savedContactId,
      label: i.contact.contactName,
    }));
  }

  return (
    <FormItem
      label="Select one of your saved contacts, or enter new details"
      fillWidth
    >
      <Dropdown
        value={props.savedContactId}
        onChange={props.onSetSavedContactId}
        options={dropdownContactOptions(props.savedContacts)}
        placeholder="Select a contact"
        data-testid="saved-contacts-dropdown"
      />
    </FormItem>
  );
};
export default BookShipmentSavedContactsDropdown;
